import React, { useEffect, useState } from "react";

// import logo from "../Assets/Montra new logo.png"; // Default logo
import montraLogo from "../Assets/Montra new logo.png";
import bsaLogo from "../Assets/BSA_Logo.png";
import herculesLogo from "../Assets/Hercules_Web_Logo.png";
import machcityLogo from "../Assets/Machcity_Logo.png";
import fitnessLogo from "../Assets/herculesfitnesslogo.png";
import trackTrailLogo from "../Assets/trackandtrail_newlogo.png";
import { useNavigate } from "react-router";
import { EsseCloseCircleO } from "lovedicons/dist/esseO";
import { ax_analytics_fetchAnalytics } from "../api/analytics";

const Sidebar = ({
  setShowSidebar,
  setCreatedFromBrand,
  togglePopupShow,
  handleShowAddUser,
}) => {
  const navigate = useNavigate();

  const [activeBrand, setActiveBrand] = useState(null);
  const [frozenBrand, setFrozenBrand] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [perBrandAnalystics, setPerBrandAnalytics] = useState(null);

  const handleMouseEnter = (brand) => {
    setActiveBrand(brand);
  };

  const handleMouseLeave = () => {
    setActiveBrand(null);
  };

  const handleClick = (brand) => {
    setFrozenBrand(frozenBrand === brand ? null : brand);
    setSelectedBrand(brand); // Update the selected brand
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const brands = [
    {
      name: "Track & Trail",
      claimData: {
        Approved: perBrandAnalystics?.bsa?.Approved,
        Pending: perBrandAnalystics?.bsa?.Pending,
        Rejected: perBrandAnalystics?.bsa?.Rejected,
      },
      logo: trackTrailLogo,
      createdFromBrand: "trackAndTrail",
    },
    {
      name: "Montra",
      claimData: { Approved: 68, Pending: 18, Rejected: 1 },
      logo: montraLogo,
      createdFromBrand: "montra",
    },
    {
      name: "BSA",
      claimData: { Approved: 34, Pending: 10, Rejected: 2 },
      logo: bsaLogo,
      createdFromBrand: "bsa",
    },
    {
      name: "Hercules",
      claimData: { Approved: 45, Pending: 12, Rejected: 0 },
      logo: herculesLogo,
      createdFromBrand: "hercules",
    },
    {
      name: "Machcity",
      claimData: { Approved: 45, Pending: 12, Rejected: 0 },
      logo: machcityLogo,
      createdFromBrand: "machcity",
    },
    {
      name: "Hercules Fitness",
      claimData: { Approved: 45, Pending: 12, Rejected: 0 },
      logo: fitnessLogo,
      createdFromBrand: "herculesFitness",
    },
  ];

  const onClaimClick = (createdFromBrand, brand) => {
    navigate("/claimList");
    setShowSidebar(false);
    setCreatedFromBrand(createdFromBrand);
    setSelectedBrand(brand.name);
    setActiveBrand(brand);
    setFrozenBrand(frozenBrand === brand ? null : brand);
  };

  const onBrandNameClick = (createdFromBrand, brand) => {
    navigate("/");
    setCreatedFromBrand(createdFromBrand);
    setShowSidebar(false);
    setSelectedBrand(brand.name);
    setActiveBrand(brand);
    setFrozenBrand(frozenBrand === brand ? null : brand);
  };

  const fetchAnalyticsDataSidebar = async () => {
    const res = await ax_analytics_fetchAnalytics();
    if (res?.data) setPerBrandAnalytics(res?.data?.perBrand);
  };

  useEffect(() => {
    fetchAnalyticsDataSidebar();
  }, []);
  // console.log(perBrandAnalystics);
  // console.log("sidebar",selectedBrand);

  const token = sessionStorage?.getItem("userToken");
  let tokenPayload = null;

  if (token) {
    try {
      const arrayToken = token.split(".");
      tokenPayload = JSON.parse(atob(arrayToken[1]));
    } catch (error) {
      console.error("Invalid token format:", error);
    }
  }

  const renderClaimData = (createdFromBrand, perBrandAnalytics) => {
    if (!perBrandAnalytics || !perBrandAnalytics[createdFromBrand]) {
      return <div className="text-gray-500">No data available</div>;
    }
    // console.log("createdFromBrand - ", createdFromBrand);
    // console.log("perBrandAnalytics - ", perBrandAnalytics);
    const brandAnalytics = perBrandAnalytics[createdFromBrand];
    return ["Approved", "Pending", "Rejected"].map((status) => (
      <div
        key={status}
        className="flex flex-col justify-center items-center gap-y-2"
      >
        <span
          className={`${
            status === "Approved"
              ? "text-[#5FBB0B]"
              : status === "Pending"
              ? "text-yellow-500"
              : "text-[#EF4444]"
          } font-medium text-[12px]`}
        >
          {status}
        </span>
        <span
          className={`${
            status === "Approved"
              ? "text-[#5FBB0B]"
              : status === "Pending"
              ? "text-yellow-500"
              : "text-[#EF4444]"
          } text-[22px] font-bold`}
        >
          {brandAnalytics[status] || "0"}
        </span>
      </div>
    ));
  };

  return (
    <div className="w-fit h-full p-5 flex flex-row bg-white rounded-lg">
      <div className="w-[250px] h-full">
        <div className="h-full flex flex-col">
          <button
            className="xl:hidden mb-1 flex justify-end"
            onClick={() => {
              setShowSidebar(false);
            }}
          >
            <EsseCloseCircleO className="w-6 h-7 text-black" />
          </button>
          <div
            className="w-full h-[50px] my-3 md:my-6 flex items-center justify-center"
            onClick={() => navigate("/")}
          >
            <img
              src={
                selectedBrand
                  ? brands.find((b) => b.name === selectedBrand).logo
                  : trackTrailLogo
              }
              alt={`${selectedBrand || "Default"} Logo`}
              className="w-[190px]"
            />
          </div>
          <section className="h-full">
            <div className="overflow-y-auto h-[calc(100vh-241px)] no-scrollbar">
              {/* <div className="overflow-y-auto h-[480px] flex-grow"> */}
              {brands.map((brand) => (
                <div
                  key={brand.name}
                  onMouseEnter={() => handleMouseEnter(brand.name)}
                  onMouseLeave={handleMouseLeave}
                  onClick={() => handleClick(brand.name)}
                  className={`py-4 hover:w-full hover:ml-0 shadow-lg rounded-lg mb-4 transition-all duration-300 ${
                    activeBrand === brand.name || frozenBrand === brand.name
                      ? "h-40"
                      : "h-16"
                  } overflow-hidden`}
                >
                  <h2
                    className={`${
                      activeBrand === brand.name || frozenBrand === brand.name
                        ? ""
                        : "ml-10"
                    } px-4 text-lg font-semibold text-black cursor-pointer`}
                    onClick={() =>
                      onBrandNameClick(brand?.createdFromBrand, brand?.name)
                    }
                  >
                    {brand.name}
                  </h2>
                  {(activeBrand === brand.name ||
                    frozenBrand === brand.name) && (
                    <div>
                      <div className="px-4 mt-2 flex gap-10 text-sm cursor-default">
                        {perBrandAnalystics &&
                          renderClaimData(
                            brand?.createdFromBrand,
                            perBrandAnalystics
                          )}
                        {/* {renderClaimData(
                          brand?.createdFromBrand,
                          perBrandAnalystics
                        )} */}
                      </div>
                      <div
                        className="mt-3 px-4 w-full flex items-center justify-between"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          className="text-md font-semibold text-black cursor-pointer"
                          onClick={() =>
                            onClaimClick(brand?.createdFromBrand, brand?.name)
                          }
                        >
                          Claim
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="relative scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
              <div
                className="flex items-center justify-between cursor-pointer"
                onClick={toggleDropdown}
              >
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-gray-700"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <circle cx="12" cy="8" r="4" />
                      <path d="M4 20c0-4 4-6 8-6s8 2 8 6H4z" />
                    </svg>
                  </div>
                  <div>
                    {/* {JSON.stringify(tokenPayload)} */}
                    <h3 className="text-lg font-semibold text-black">
                      {tokenPayload?.username}
                    </h3>
                    <p className="text-xs text-gray-500">
                      {tokenPayload?.email.length > 28
                        ? `${tokenPayload.email.slice(0, 25)}...`
                        : tokenPayload?.email}
                    </p>
                  </div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`h-6 w-6 transform transition-transform duration-300 ${
                    isDropdownOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>

              {isDropdownOpen && (
                <div className="absolute -top-24 left-0 w-full bg-white rounded-lg shadow-lg z-10 max-h-40 overflow-y-auto">
                  <ul className="max-h-48 overflow-y-auto ">
                    <li
                      onClick={() => {
                        togglePopupShow();
                        setIsDropdownOpen(false);
                      }}
                      className="flex items-center justify-between px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg cursor-pointer"
                    >
                      Log Out
                      <svg
                        width="12"
                        height="11"
                        viewBox="0 0 12 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.75 2.33333L7.9275 3.15583L9.4325 4.66667H3.5V5.83333H9.4325L7.9275 7.33833L8.75 8.16667L11.6667 5.25M1.16667 1.16667H5.83333V0H1.16667C0.525 0 0 0.525 0 1.16667V9.33333C0 9.975 0.525 10.5 1.16667 10.5H5.83333V9.33333H1.16667V1.16667Z"
                          fill="#1E1E1E"
                          fill-opacity="0.5"
                        />
                      </svg>
                    </li>
                    <li
                      onClick={() => {
                        handleShowAddUser();
                        setIsDropdownOpen(false);
                      }}
                      className="flex items-center justify-between px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg cursor-pointer"
                    >
                      Add User
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.00065 4.99967C4.38181 4.99967 3.78832 4.75384 3.35074 4.31626C2.91315 3.87867 2.66732 3.28518 2.66732 2.66634C2.66732 2.0475 2.91315 1.45401 3.35074 1.01643C3.78832 0.57884 4.38181 0.333008 5.00065 0.333008C5.61949 0.333008 6.21298 0.57884 6.65057 1.01643C7.08815 1.45401 7.33398 2.0475 7.33398 2.66634C7.33398 3.28518 7.08815 3.87867 6.65057 4.31626C6.21298 4.75384 5.61949 4.99967 5.00065 4.99967ZM5.00065 6.74967C6.85915 6.74967 8.5269 7.08276 9.66732 8.53642V9.66634H0.333984V8.53642C1.4744 7.08217 3.14215 6.74967 5.00065 6.74967Z"
                          fill="#1E1E1E"
                          fill-opacity="0.5"
                        />
                      </svg>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
      {/* <div className="w-fit">
        <Analytics />
        <Warrantylist />
      </div> */}
    </div>
  );
};

export default Sidebar;
